fragment ProductCategoryFragment on ProductCategory {
    id
    name
    createdTime
    numAssociatedProducts
    reportLink
}
